import { CartLinesUpdateEvent } from '@shopify/events';
window.topicsCartActionsReady = true;

// Enhance native forms. If this module cannot load, normal Shopify forms still work.
document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-tf-quick-add],.tf-quick-buy,.tf-outfit-form:has([data-outfit-select])')) return;
  event.preventDefault();
  if (form.dataset.busy || !form.reportValidity()) return;
  form.dataset.busy = 'true';
  const button = form.querySelector('button[type="submit"]');
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Toevoegen…';
  form.setAttribute('aria-busy', 'true');
  let status = form.querySelector('[data-tf-cart-status]');
  if (!status) {
    status = document.createElement('p');
    status.dataset.tfCartStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.append(status);
  }
  status.textContent = '';
  let added = false;
  try {
    const data = new FormData(form);
    data.delete('return_to');
    const outfitSelects = [...form.querySelectorAll('[data-outfit-select]')];
    let lines;
    if (outfitSelects.length) {
      const selected = outfitSelects.filter(select => select.value && !select.selectedOptions[0].disabled);
      if (!selected.length) throw new Error('Kies eerst een maat voor minstens één artikel.');
      for (const key of [...data.keys()]) if (key.startsWith('items[')) data.delete(key);
      selected.forEach((select, index) => {
        data.set(`items[${index}][id]`, select.value);
        data.set(`items[${index}][quantity]`, '1');
      });
      lines = selected.map(select => ({merchandiseId: select.value, quantity: 1}));
    } else {
      lines = [{merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) || 1}];
    }
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    if (sectionIds.length) data.set('sections', sectionIds.join(','));
    data.set('sections_url', location.pathname);
    const endpoint = new URL(form.action);
    endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
    const response = await fetch(endpoint, {method: 'POST', body: data, headers: {Accept: 'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Toevoegen lukt niet. Controleer je maat en probeer opnieuw.');
    added = true;
    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
    if (!cartResponse.ok) throw new Error('De tas kon niet worden vernieuwd.');
    const cart = await cartResponse.json();
    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines,
      promise: Promise.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {items: cart.items, sections: result.sections, itemCount: cart.item_count, source: 'topics-product-form', didError: false}}),
    }));
    status.textContent = 'Toegevoegd aan je tas.';
    const dialog = form.closest('dialog');
    if (dialog?.open) dialog.close();
    requestAnimationFrame(() => {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  } catch (error) {
    // A successful add followed by a refresh failure must never invite a duplicate add.
    status.textContent = added ? 'Toegevoegd. Open je tas om de inhoud te bekijken.' : (error instanceof TypeError ? 'Geen bevestiging ontvangen. Controleer je tas voordat je opnieuw toevoegt.' : error.message);
  } finally {
    const link = document.createElement('a');
    link.href = (window.Shopify?.routes?.root || '/') + 'cart';
    link.textContent = ' Bekijk je tas';
    status.append(link);
    button.disabled = false;
    button.textContent = originalText;
    form.removeAttribute('aria-busy');
    delete form.dataset.busy;
  }
});
